"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.getArrowStyle = function (placement, bubbleBorderWidth, arrowBorderWidth, borderStyle, borderColor, tooltipSize) {
  var isBottom = Boolean(placement && placement.indexOf('bottom') === 0);
  var isLeft = Boolean(placement && placement.indexOf('left') === 0);
  var isRight = Boolean(placement && placement.indexOf('right') === 0);
  var isTop = Boolean(placement && placement.indexOf('top') === 0);
  var offset = Math.ceil(0 - tooltipSize / 2) - bubbleBorderWidth;
  return __assign({}, isBottom ? {
    borderTopWidth: arrowBorderWidth,
    borderTopStyle: borderStyle,
    borderTopColor: borderColor,
    borderLeftWidth: arrowBorderWidth,
    borderLeftStyle: borderStyle,
    borderLeftColor: borderColor,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    top: offset
  } : {}, isTop ? {
    borderBottomWidth: arrowBorderWidth,
    borderBottomColor: borderColor,
    borderBottomStyle: borderStyle,
    borderRightWidth: arrowBorderWidth,
    borderRightStyle: borderStyle,
    borderRightColor: borderColor,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    bottom: offset
  } : {}, isRight ? {
    borderLeftWidth: arrowBorderWidth,
    borderLeftColor: borderColor,
    borderLeftStyle: borderStyle,
    borderBottomWidth: arrowBorderWidth,
    borderBottomColor: borderColor,
    borderBottomStyle: borderStyle,
    borderRightWidth: 0,
    borderTopWidth: 0,
    left: offset
  } : {}, isLeft ? {
    borderRightWidth: arrowBorderWidth,
    borderRightColor: borderColor,
    borderRightStyle: borderStyle,
    borderTopWidth: arrowBorderWidth,
    borderTopColor: borderColor,
    borderTopStyle: borderStyle,
    borderLeftWidth: 0,
    borderBottomWidth: 0,
    right: offset
  } : {}, {
    position: 'absolute',
    height: tooltipSize,
    width: tooltipSize,
    transform: 'rotate(45deg)'
  });
};

exports.getContainerStyle = function (placement, borderWidth, tooltipSize) {
  var isBottom = Boolean(placement && placement.indexOf('bottom') === 0);
  var isLeft = Boolean(placement && placement.indexOf('left') === 0);
  var isRight = Boolean(placement && placement.indexOf('right') === 0);
  var isTop = Boolean(placement && placement.indexOf('top') === 0);
  var offset = Math.floor(tooltipSize / 2) + borderWidth;
  return __assign({}, isBottom ? {
    marginTop: offset
  } : {}, isTop ? {
    marginBottom: offset
  } : {}, isLeft ? {
    marginRight: offset
  } : {}, isRight ? {
    marginLeft: offset
  } : {});
};